/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  public apiData = [];
  public onApiDataChange: BehaviorSubject<any>;

  constructor(private _httpClient: HttpClient) {
    this.onApiDataChange = new BehaviorSubject('');
    this.getNotificationsData();
  }

  public getNotificationsData(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._httpClient.get('api/notifications-data').subscribe({
        next: (response: any) => {
          this.apiData = response;
          this.onApiDataChange.next(this.apiData);
          resolve(this.apiData);
        },
        error: reject,
      });
    });
  }
}
